/* eslint-disable no-alert */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import {
  Card, CardBody, CardTitle, Col, Row,
} from 'reactstrap';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';
import { post } from '../../helpers/api_helper';
import ShipMethodMappingFormModal from '../../components/Settings/ShipMethodMapping/ShipMethodMappingFormModal';

function ShipMethodMappings(props) {
  const { t } = props;

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
    timeOut: 8000,
  };

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editModalMapping, setEditModalMapping] = useState({});
  const [signal, setSignal] = useState(0);

  const editMapping = (mapping) => {
    setEditModalMapping(mapping);
    setEditModalOpen(true);
  };

  const onEditSuccess = () => {
    setSignal((prev) => prev + 1);
    setEditModalOpen(false);
    setEditModalMapping({});
  };

  const deleteMapping = async (mapping, e) => {
    const btn = e.currentTarget;

    btn.disabled = true;
    btn.blur();
    btn.firstChild.classList.toggle('bx-spin');

    const label = mapping.carrier && mapping.service_name
      ? `${mapping.carrier} / ${mapping.service_name}`
      : mapping.ship_method_code;
    const cnfrm = window.confirm(t(`Are you sure you want to delete ${label}?`));

    if (cnfrm) {
      try {
        await post(`/api/orders/shipping/mappings/${mapping.id}/delete`);
        toastr.success(t(`Deleted mapping: ${label}`), t('Success'));
        setSignal((prev) => prev + 1);
      } catch (error) {
        toastr.error(error.message, t('Error'));
      } finally {
        btn.disabled = false;
        btn.firstChild.classList.toggle('bx-spin');
      }
    } else {
      btn.disabled = false;
      btn.firstChild.classList.toggle('bx-spin');
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xxl="12">
            <Card>
              <CardBody>
                <CardTitle className="h4">{t('Shipping Method Mappings')}</CardTitle>

                <Can i="see" this="Settings">
                  <BaseGrid
                    url="/api/orders/shipping/mappings"
                    hasSearch
                    shouldUpdate={signal}
                    create={() => {
                      setEditModalMapping({});
                      setEditModalOpen(true);
                    }}
                    createText="New Mapping"
                    config={{
                      columns: {
                        id: { label: 'ID', sort: true },
                        ship_method_code: { label: 'Ship Method Code', sort: true },
                        carrier: { label: 'Carrier', sort: true },
                        service_name: { label: 'Service Name', sort: true },
                        account_number: {
                          label: 'Shipping Account Number',
                          sort: true,
                          format: (value) => value || '',
                        },
                        reference_match: {
                          label: 'Reference Match',
                          sort: true,
                          format: (value) => value || '',
                        },
                        max_weight: {
                          label: 'Max Weight',
                          sort: true,
                          format: (value) => (value == null || value === '' ? '-' : value),
                        },
                        preferred_methods: {
                          label: 'Preferred Matches',
                          sort: false,
                          html: true,
                          format: (value) => (Array.isArray(value) ? value.join('<br />') : ''),
                        },
                        is_active: {
                          label: 'Status',
                          sort: true,
                          format: (value) => (value ? 'Active' : 'Inactive'),
                        },
                        notes: {
                          label: 'Notes',
                          sort: false,
                          format: (value) => value || '',
                        },
                        actions: {
                          label: t('Actions'),
                          actions: [
                            {
                              key: 'edit',
                              icon: 'bx bx-pencil',
                              class: 'btn btn-sm btn-soft-dark',
                              alt: t('Edit'),
                              click: editMapping,
                            },
                            {
                              key: 'delete',
                              icon: 'mdi mdi-delete',
                              class: 'btn btn-sm btn-soft-danger',
                              alt: t('Delete'),
                              click: deleteMapping,
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'carrier',
                        direction: 'asc',
                        perPage: 30,
                      },
                    }}
                  />

                  <ShipMethodMappingFormModal
                    shown={editModalOpen}
                    mapping={editModalMapping}
                    onSuccess={onEditSuccess}
                    onClose={() => {
                      setEditModalOpen(false);
                      setEditModalMapping({});
                    }}
                  />
                </Can>

                <Can not i="see" this="Settings"><p>{t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

ShipMethodMappings.defaultProps = {
  t: (x) => x,
};

ShipMethodMappings.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({}), {})(withTranslation()(ShipMethodMappings));
